import React from 'react';

interface Investment {
    symbol: string;
    modelPercentage: string;
    investmentAmount: string;
    actualPercentage: string;
}

interface InvestmentTableProps {
    investments: Investment[];
    totalCash: number;
    totalInvestment: number;
}

const InvestmentTable: React.FC<InvestmentTableProps> = ({ investments, totalCash, totalInvestment }) => {
    return (
        <div className='investment-table-container'>
            <div className='investment-header'>
                <div className='header-title'>Assigned Securities Breakdown</div>
                <div className='header-values'>
                    <span className='cash-value-table'>
                        Cash: <span className='value'>${totalCash?.toLocaleString()}</span>
                    </span>
                    <span className='investment-value-table'>
                        Investment: <span className='value'>${totalInvestment?.toLocaleString()}</span>
                    </span>
                </div>
            </div>

            <table className='investment-table'>
                <thead>
                    <tr>
                        <th>Security Type</th>
                        <th>Model %</th>
                        <th>Investment Amount</th>
                        <th>Amount %</th>
                    </tr>
                </thead>
            </table>

            <div className='table-body-wrapper'>
                <table className='investment-table'>
                    <tbody>
                        {investments.length < 1 ? (
                            <tr>
                                <td
                                    colSpan={4}
                                    style={{ padding: 0 }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            height: '250px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        <img
                                            src='/NoData.png'
                                            alt='No data'
                                            style={{
                                                maxWidth: '200px',
                                                opacity: 0.7,
                                                marginBottom: '1rem',
                                            }}
                                        />
                                        <span style={{ fontSize: '1rem', color: '#6b7280' }}>No data available</span>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            investments.map((investment, index) => (
                                <tr key={index}>
                                    <td>{investment?.symbol}</td>
                                    <td>{parseFloat(parseFloat(investment?.modelPercentage).toFixed(4))}%</td>
                                    <td>${parseFloat(parseFloat(investment?.investmentAmount).toFixed(4))}</td>
                                    <td>{parseFloat(parseFloat(investment?.actualPercentage).toFixed(4))}%</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <style>
                {`
          .investment-table-container {
            font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            max-width: 100%;
            overflow-x: auto;
            border-radius: 8px;
            background-color: white;
          }

          .investment-header {
            height: 78.5px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 20px;
            border-bottom: 1px solid #e2e8f0;
          }

          .header-title {
            font-size: 18px;
            font-weight: 600;
            color: #1a202c;
          }

          .header-values {
            display: flex;
            gap: 20px;
          }

          .cash-value-table, .investment-value-table {
            font-weight: 600;
          }

          .value {
            color: #0066A6;
            font-weight: 600;
          }

          .table-body-wrapper {
            max-height: 250px;
            overflow-y: auto;
          }

          .investment-table {
            width: 100%;
            border-collapse: collapse;
            table-layout: fixed;
          }

          .investment-table th {
            text-align: left;
            padding: 16px 24px;
            font-weight: 700;
            color: #667085;
            background-color: #f7fafc;
            border-bottom: 1px solid #e2e8f0;
            position: sticky;
            top: 0;
            font-size: 14px;
          }

          .investment-table td {
            padding: 16px 24px;
            border-bottom: 1px solid #e2e8f0;
            color: #4a5568;
          }

          .investment-table tbody tr:last-child td {
            border-bottom: none;
          }

          .investment-table tbody tr:hover {
            background-color: #f7fafc;
          }
        `}
            </style>
        </div>
    );
};

export default InvestmentTable;
